/**
 * Horizon Pro — Countdown Timer
 * Web component for announcement bar countdown timers.
 * Renders "Ends in Xd Xh Xm Xs". On expiry: hides slide or shows expired text.
 */
class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.endDate = new Date(this.getAttribute('end-date'));
    this.expiredAction = this.getAttribute('expired-action') || 'hide';
    this.expiredText = this.getAttribute('expired-text') || '';
    this.slideEl = this.closest('.announcement-bar-component__slide, .announcement-bar__slide, [class*="announcement"]');

    if (isNaN(this.endDate.getTime())) {
      this.textContent = '';
      return;
    }

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  update() {
    const now = Date.now();
    const diff = this.endDate.getTime() - now;

    if (diff <= 0) {
      clearInterval(this.interval);
      this.handleExpiry();
      return;
    }

    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const mins = Math.floor((diff % 3600000) / 60000);
    const secs = Math.floor((diff % 60000) / 1000);

    let parts = [];
    if (days > 0) parts.push(days + 'd');
    parts.push(hours + 'h');
    parts.push(mins + 'm');
    parts.push(secs + 's');

    this.textContent = 'Ends in ' + parts.join(' ');
  }

  handleExpiry() {
    if (this.expiredAction === 'hide' && this.slideEl) {
      this.slideEl.style.display = 'none';
    } else if (this.expiredAction === 'show-text' && this.expiredText) {
      this.textContent = this.expiredText;
    } else {
      this.textContent = '';
    }
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
